// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/content-documents/media-document/match-sentence/match-sentence.component.scss
// module id = 157
// module chunks = 0